import { axiosInstance } from "@src/api/axiosConfig";
import { StatusItemPath } from "@src/api/axiosPath";
import { StatusItemType } from "@src/types/item.type";
import { AxiosError } from "axios";
import { useQuery } from "react-query";

// VVIP 상태변경 매물
const fetchStatusItems = async (): Promise<StatusItemType[]> => {
    const { data } = await axiosInstance.get<StatusItemType[]>(StatusItemPath);
    return data;
};

export const useGetStatusItems = () => {
    return useQuery<StatusItemType[], AxiosError>(["statusItems"], fetchStatusItems);
};
